<template>
    <div>
        <b-button variant="success" size="sm" class="ml-2" @click="() => this.$refs['upload-modal'].show()">
            <b-icon icon="upload" />
            {{ title }}
        </b-button>


        <b-modal ref="upload-modal" :title="this.title" ok-only>
            <p>
                Încarcă fișierul de import
            </p>

            <b-alert :show="!!errorMessage" variant="danger">
                <h4>Eroare la import</h4>
                <p>Serverul a răspuns cu: {{errorMessage}}</p>
                <p>Vă rugăm să respectați formatul și structura fișierului de import.</p>
            </b-alert>

            <b-form-file
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Alege un fișier sau trage-l aici"
                    drop-placeholder="Trage fișierul aici"
            ></b-form-file>

            <template v-slot:modal-footer="{ close }">
                <div class="w-100">
                    <b-button
                            variant="secondary"
                            size="sm"
                            class="mr-2"
                            @click="close()"
                    >
                        Închide
                    </b-button>
                    <b-button
                            variant="primary"
                            size="sm"
                            class="float-right"
                            @click="uploadFile"
                    >
                        Salvează
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import axios from "@/utils/axios-instance";

    export default {
        name: "ImportUploader",
        props: {
            title: String,
            url: String,
            filename: {
                type: String,
                default: 'products',
            }
        },
        data() {
            return {
                file: null,
                errorMessage: null,
            }
        },
        methods: {
            async uploadFile() {
                let loader = this.$loading.show({
                    container: this.$refs.currentOffer,
                });

                try {
                    let formData = new FormData();

                    formData.append(this.filename, this.file);
                    await axios.post(this.url,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    );

                    this.$refs['upload-modal'].hide()
                    this.$bvToast.toast(`Fișierul a fost încăcat cu succes!`, {
                        title: 'Succes!',
                        autoHideDelay: 5000,
                    })
                } catch (e) {
                    console.log(e)
                    if (e.response) {
                        if(e.response.data && e.response.data.message) {
                            this.errorMessage = e.response.data.message;
                        }
                    }
                }

                loader.hide();
            }
        }
    }
</script>

<style scoped>

</style>